import React from "react";

const WhyBinaryOps = () => {
  const features = [
    {
      number: "01",
      title: "Skilled and experienced development team",
    },
    {
      number: "02",
      title: "Proven track record of successful projects",
    },
    {
      number: "03",
      title: "Transparent and collaborative approach",
    },
    {
      number: "04",
      title: "Cost-effective solutions without compromising quality",
    },
  ];

  return (
    <section className="md:px-10 px-5 py-7 max-w-[1280px] mx-auto bg-white text-center">
     <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
     Why Binary Ops
        </h2>
        <div className="underline md:w-1/6 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-black">
          <p className="h-[5px] rounded-xl bg-primary md:w-[50%] w-[70%]"></p>
        </div>     
      <div className="grid grid-cols-1 sm:grid-cols-2 small:gap-12 gap-5 py-10  max-w-[1000px] mx-auto">
        {features.map((feature, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center sm:flex-row sm:items-start sm:text-left gap-5"
          >
            <div className="rounded-full border-[1px] border-dashed border-[#FFC300]  text-[#0965AC] font-bold text-2xl sm:text-4xl size-24 shadow-xl flex items-center justify-center ">
              {feature.number}
            </div>
            <p className="text-base sm:text-lg flex self-center font-medium text-gray-800 max-w-xs">
              {feature.title}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyBinaryOps;
